import React from "react";

const TeamAll = React.createContext();

export default TeamAll;
